const type = 'advanced'
const path = 'client/react'
const name = 'PaymentForm.module.css'
const fullPath = `${path}/${name}`

export { type, path, name, fullPath }
